module.exports = __webpack_public_path__ + "media/images/app-store-badge-f0b2da6ae624c644b0ad82d76dc94191.svg";